import { formatDecimalPlaces, percentageFromDecimal } from '@sequencehq/utils'

/**
 * The percentage to label a tax row with, e.g. '20' for a 0.2 rate. Undefined
 * when the line items carry differing rates, so there's no single one to show.
 */
export const getTaxPercentage = (
  lineItems: { taxRate: string }[]
): string | undefined => {
  const percentages = new Set(
    lineItems.map(lineItem =>
      formatDecimalPlaces(percentageFromDecimal(lineItem.taxRate), 2)
    )
  )

  return percentages.size === 1 ? [...percentages].at(0) : undefined
}
